import { render, staticRenderFns } from "./CjhdSuccess.vue?vue&type=template&id=2427e34a&scoped=true"
import script from "./CjhdSuccess.vue?vue&type=script&lang=js"
export * from "./CjhdSuccess.vue?vue&type=script&lang=js"
import style0 from "./CjhdSuccess.vue?vue&type=style&index=0&id=2427e34a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2427e34a",
  null
  
)

export default component.exports